//
//
//
//
//
//
//
//
//
//
//

import financingProjectStatusConfig from '@/config/financingPorjectStatus.config';

export default {
    props: {
        status: {
            type: String,
            default: 'Status',
        },
        align: {
            type: String,
            default: undefined,
        },
    },
    computed: {
        config() {
            if (financingProjectStatusConfig[this.status]) {
                return financingProjectStatusConfig[this.status];
            }

            return {
                color: 'grey-3',
                textColor: 'primary',
                text: this.status,
            };
        },
    },
};
